// Statuts des objectifs, tels que la roadmap les montre.

export const STATUS = {
  done: { label: 'terminé', dot: 'bg-emerald-500', text: 'text-slate-400 line-through' },
  in_progress: { label: 'en cours', dot: 'bg-amber-400', text: 'text-slate-700' },
  blocked: { label: 'bloqué', dot: 'bg-rose-500', text: 'text-rose-700' },
  not_started: { label: 'à faire', dot: 'bg-slate-300', text: 'text-slate-700' },
};

export const STATUS_ORDER = { blocked: 0, in_progress: 1, not_started: 2, done: 3 };

export const STATUS_OPTIONS = [
  { value: 'not_started', label: 'À faire' },
  { value: 'in_progress', label: 'En cours' },
  { value: 'blocked', label: 'Bloqué' },
  { value: 'done', label: 'Terminé' },
];
